import type { LayoutDataType } from '../../types';

export const PERSONAL_OPTIONS: {
  id: NonNullable<LayoutDataType['personal']>;
  title: string;
}[] = [
  {
    id: 'flirt',
    title: 'Flirt back',
  },
  {
    id: 'professional',
    title: 'Keep it professional (for now)',
  },
  {
    id: 'pretend',
    title: "Pretend you didn't hear",
  },
];
